export type GridXYV2<T> = Array<T>

export default function createGridXYV2<T>(
  gridWidth: number,
  gridHeight: number,
  defaultValue: T
): GridXYV2<T> {
  const grid: GridXYV2<T> = Array(gridWidth * gridHeight).fill(defaultValue)

  return grid
}
